/* Advertorial Artikel — Facebook-stijl reacties.
   Likes toggelen client-side; "reacties" worden NOOIT verzonden of opgeslagen
   — ze worden alleen lokaal in de DOM getoond zodat het lijkt of er geplaatst is.
   Eén globale, idempotente init die alle .art-fb-blokken op de pagina bedient. */
(function () {
  if (window.__ADV_FB__) { window.__ADV_FB__.scan(); return; }

  function esc(s) {
    return (s || '').replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function badgeFor(actions) {
    var body = actions.parentElement;
    return body ? body.querySelector(':scope > .art-fb-bubble-wrap > .art-fb-likecount') : null;
  }

  function refreshLike(actions) {
    var base = parseInt(actions.getAttribute('data-base') || '0', 10);
    var liked = actions.getAttribute('data-liked') === '1';
    var n = base + (liked ? 1 : 0);
    var badge = badgeFor(actions);
    if (badge) {
      var num = badge.querySelector('.art-fb-likenum');
      if (num) num.textContent = n;
      badge.style.display = n > 0 ? 'inline-flex' : 'none';
    }
  }

  function avatar(root, small) {
    var url = root.getAttribute('data-visitor-avatar');
    var cls = 'art-fb-av' + (small ? ' art-fb-av--sm' : '');
    if (url) return '<span class="' + cls + '" style="background-image:url(' + url + ')"></span>';
    return '<span class="' + cls + ' art-fb-av--ph" style="background:' +
      root.getAttribute('data-visitor-color') + '">' +
      esc(root.getAttribute('data-visitor-initial')) + '</span>';
  }

  function node(root, text, isReply) {
    return '<div class="art-fb-comment' + (isReply ? ' art-fb-reply-item' : '') + '">' +
      avatar(root, isReply) +
      '<div class="art-fb-body">' +
        '<div class="art-fb-bubble-wrap">' +
          '<div class="art-fb-bubble">' +
            '<a class="art-fb-name" href="#" onclick="return false">' + esc(root.getAttribute('data-visitor-name')) + '</a>' +
            '<div class="art-fb-text">' + esc(text) + '</div>' +
          '</div>' +
          '<span class="art-fb-likecount" style="display:none"><span class="art-fb-thumb">👍</span><span class="art-fb-likenum">0</span></span>' +
        '</div>' +
        '<div class="art-fb-actions" data-base="0" data-liked="0">' +
          '<button class="art-fb-like" type="button">' + esc(root.getAttribute('data-like-label')) + '</button>' +
          (isReply ? '' : '<button class="art-fb-reply" type="button">' + esc(root.getAttribute('data-reply-label')) + '</button>') +
          '<span class="art-fb-time">' + esc(root.getAttribute('data-now-label')) + '</span>' +
        '</div>' +
        (isReply ? '' : '<div class="art-fb-replies"></div>') +
      '</div>' +
    '</div>';
  }

  function onClick(e) {
    var root = e.target.closest('.art-fb');
    if (!root) return;

    var like = e.target.closest('.art-fb-like');
    if (like) {
      var a = like.closest('.art-fb-actions');
      var liked = a.getAttribute('data-liked') === '1';
      a.setAttribute('data-liked', liked ? '0' : '1');
      like.classList.toggle('is-liked', !liked);
      refreshLike(a);
      return;
    }

    var reply = e.target.closest('.art-fb-reply');
    if (reply) {
      var body = reply.closest('.art-fb-body');
      var box = body.querySelector(':scope > .art-fb-replybox');
      if (box) {
        box.hidden = !box.hidden;
        if (!box.hidden) { var t = box.querySelector('textarea'); if (t) t.focus(); }
      }
      return;
    }

    var post = e.target.closest('.art-fb-post');
    if (post) {
      var comp = post.closest('.art-fb-composer');
      var ta = comp.querySelector('textarea');
      var val = (ta.value || '').trim();
      if (!val) return;
      var isReply = comp.classList.contains('art-fb-composer--reply');
      var html = node(root, val, isReply);
      if (isReply) {
        var cbody = comp.closest('.art-fb-body');
        var reps = cbody.querySelector(':scope > .art-fb-replies');
        if (reps) reps.insertAdjacentHTML('beforeend', html);
        comp.hidden = true;
      } else {
        var list = root.querySelector('.art-fb-list');
        if (list) list.insertAdjacentHTML('afterbegin', html);
      }
      ta.value = '';
      ta.style.height = 'auto';
      return;
    }
  }

  function onKey(e) {
    if (e.key === 'Enter' && !e.shiftKey && e.target.matches && e.target.matches('.art-fb-composer textarea')) {
      e.preventDefault();
      var btn = e.target.closest('.art-fb-composer').querySelector('.art-fb-post');
      if (btn) btn.click();
    }
  }

  function onInput(e) {
    if (e.target.matches && e.target.matches('.art-fb-composer textarea')) {
      e.target.style.height = 'auto';
      e.target.style.height = Math.min(e.target.scrollHeight, 120) + 'px';
    }
  }

  function scan() {
    document.querySelectorAll('.art-fb:not([data-init])').forEach(function (root) {
      root.setAttribute('data-init', '1');
      root.querySelectorAll('.art-fb-actions').forEach(refreshLike);
    });
  }

  document.addEventListener('click', onClick);
  document.addEventListener('keydown', onKey);
  document.addEventListener('input', onInput);
  document.addEventListener('shopify:section:load', scan);
  if (document.readyState !== 'loading') scan();
  else document.addEventListener('DOMContentLoaded', scan);

  window.__ADV_FB__ = { scan: scan };
})();
